import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import {
  deleteSkillHelper,
  fetchAllCompanySkillsHelper,
  fetchAllCompanySuperSkillsHelper,
} from "helpers/backend_helper";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import { decryptDataFromArray } from "helpers/EncDec";

import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { useTranslation } from "react-i18next";

const SkillList = () => {
  const { t } = useTranslation();
  const [allSkills, setAllSkills] = useState([]);

  const [filters, setFilters] = useState({
    query: "",
  });

  const fetchAllCompanySkills = async () => {
    try {
      let response = await fetchAllCompanySkillsHelper({});

      let responseData = decryptDataFromArray(response);

      let companySkills = responseData?.data?.companySkills || [];

      //tranlate the super skill statically
      companySkills = companySkills.map(elem => {
        if (elem.parent_skill_tag && elem.parent_skill_tag.name) {
          elem.parent_skill_tag.name = t(
            `Location_Manager.${elem.parent_skill_tag.name}`
          );
        }
        return elem;
      });
      setAllSkills(companySkills);
    } catch (error) {
      toast.error(t(`Location_Manager.No skills available`));
      setAllSkills([]);
    }
  };

  useEffect(() => {
    fetchAllCompanySkills();

    return () => {};
  }, []);

  const handleDeleteSkill = async skillId => {
    let deleteConfirm = window.confirm(
      t(`Location_Manager.Delete skill confirmation`)
    );

    if (!deleteConfirm) {
      return;
    }

    try {
      let response = await deleteSkillHelper({
        skillId: skillId,
      });

      toast.success(t(`Location_Manager.Skill deleted`));

      fetchAllCompanySkills();
    } catch (error) {
      toast.error(t(`Location_Manager.Delete skill failed`));
    }
  };

  const columns = [
    {
      dataField: "name",
      text: t(`Location_Manager.Skill Name`),
    },
    {
      dataField: "parent_skill_tag.name",
      text: t(`Location_Manager.Super Skill`),
      classes: "white-hidden",
    },
    {
      dataField: "description",
      text: t(`Location_Manager.Skill Description`),
      classes: "white-hidden",
    },
  ];

  if (
    !!checkPermissionStatus("skill-list", "edit") ||
    !!checkPermissionStatus("skill-list", "delete")
  ) {
    columns.push({
      dataField: "id",
      text: t(`Location_Manager.Actions`),
      formatter: (skillId, skill) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              {checkPermissionStatus("skill-list", "edit") ? (
                <>
                  <Link
                    className="text-success blue-icon blue-color4"
                    to={`/edit-skill/${skillId}`}
                    // title="Edit Skill"
                  >
                    <img src={edit_icon} alt="edit_icon" />
                    <span>{t(`Location_Manager.Edit Skill`)}</span>
                  </Link>
                </>
              ) : (
                <></>
              )}
            </div>

            <div className="action-one small-img">
              {checkPermissionStatus("skill-list", "delete") ? (
                <>
                  <div
                    className="text-success blue-icon blue-color3"
                    role="button"
                    // title="Delete Skill"
                    onClick={e => {
                      handleDeleteSkill(skillId);
                    }}
                  >
                    <img src={delete_icon} alt="delete_icon" />
                    <span>{t(`Location_Manager.Delete`)}</span>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        );
      },
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  if (!checkPermissionStatus("skill-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="page-content departmentpage">
        <Container fluid>
          <div className="joblist-container skilllist  applicationcard-table">
            <Row className="mb-3 align-items-center py-2 spece-low-cum2">
              <Col lg="4" md="4" className="Joblist-column">
                <div className="joblist-container create-vacancy p-0">
                  <Link to="/">
                    <h5 className="text-uppercase heading-one spece-low-cum2">
                      <img src={arrow_btn} alt="arrow_btn" />
                      {t(`Location_Manager.Skill List`)}
                    </h5>
                  </Link>
                </div>
              </Col>
              <Col lg="8" md="8">
                <div class="single-filter-box skillset-card btn-left d-flex justify-content-end align-items-center gap-2 flex-wraps">
                  <div className="serach-bar-top">
                    <form class="form-inline">
                      <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder={t(`Location_Manager.Search by skill`)}
                        aria-label="Search"
                        onChange={e => {
                          let text = e.target?.value;

                          setFilters(prevState => ({
                            ...prevState,
                            query: text,
                          }));
                        }}
                        title={t(`Location_Manager.Search by skill`)}
                      />
                      <span>
                        <img src={serach_icon} alt="search" />
                      </span>
                    </form>
                  </div>

                  {checkPermissionStatus("skill-list", "create") && (
                    <Link to="/create-skill" className="btn btn-primary">
                      {t(`Location_Manager.Create Skill`)}
                    </Link>
                  )}

                  <div className="tale-text right-panel skilltest">
                    <button
                      className="button left"
                      onClick={() => handleScroll("left")}
                      data-tooltip="Scroll Left"
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                    <button
                      className="button right"
                      onClick={() => handleScroll("right")}
                      data-tooltip="Scroll Right"
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <Row>
            <Col lg={12}>
              <div className="outerTab-box-wrapper below-vacancy  skillset-cards-po">
                <div className="timeto-hire-card userlist">
                  <div className="tabel-application tabel-application-auto table-responsive white-space-row">
                    <ToolkitProvider
                      keyField="id"
                      data={allSkills?.filter(skill => {
                        let query = filters?.query;

                        if (!query) {
                          return true;
                        }

                        let name = skill?.name;

                        let nameFlag = name
                          ?.toLowerCase()
                          ?.includes(query?.toLowerCase());

                        return nameFlag;
                      })}
                      columns={columns}
                      search
                    >
                      {props => (
                        <div className="table-custome-class range-custome">
                          <div className="scroll-container">
                            <div className="table-pending-list">
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <BootstrapTable
                                  {...props.baseProps}
                                  pagination={paginationFactory(options)}
                                  options={options}
                                  striped
                                  hover
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SkillList;
